import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './Education.css'; // Import your custom CSS file

const Education = () => {
  return (
    <Container
      className="education-container mt-5"
      style={{ color: '#ccd6f6' }}>
      <h1>Education</h1>
      {/* <hr /> */}
      <div className="my-5">
        <Row>
          <Col
            Col
            md={6}
            lg={3}
            xs={12}
            className="skill-col mx-auto py-3"
            style={{ color: '#ccd6f6' }}>
            <h3>Master of Science</h3>
            <h5>Year: 2024 - Present</h5>
            <h5>Computer Science</h5>
          </Col>
          <Col
            Col
            md={6}
            lg={3}
            xs={12}
            className="skill-col mx-auto py-3"
            style={{ color: '#ccd6f6' }}>
            <h3>Bachelor of Science</h3>
            <h5>Year: 2018 - 2021</h5>
            <h5>Computer Science & Engineering</h5>
          </Col>
          <Col
            Col
            md={6}
            lg={3}
            xs={12}
            className="skill-col mx-auto py-3"
            style={{ color: '#ccd6f6' }}>
            <h3>HSC</h3>
            <h5>Year: 2017</h5>
            <h5>Section: Science</h5>
          </Col>
          <Col
            Col
            md={6}
            lg={3}
            xs={12}
            className="skill-col mx-auto py-3"
            style={{ color: '#ccd6f6' }}>
            <h3>SSC</h3>
            <h5>Year: 2015</h5>
            <h5>Section: Science</h5>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default Education;
